export default function (instance) {
  return {
    getPaymentMethods () {
      return instance
        .get('/api/payment/methods')
        .then(response => response.data)
    },

    adyenpayment (paymentProvider, amount, sbeCompliance, orderNumber, paymentMethodCode) {
      return instance
        .post(`/api/payment/PaymentSessionRequest?paymentProvider=${paymentProvider}&amount=${amount}&sbeCompliance=${sbeCompliance}&orderNumber=${orderNumber}&paymentMethodCode=${paymentMethodCode}`)
        
        .then(response => response.data)
    },

    paymentResult (paymentResult) {
      return instance
        .post('/api/payment/result', {
          paymentResult
        })
        .then(response => response.data)
    }
  }
}
